import { render, staticRenderFns } from "./ProcessEditor.vue?vue&type=template&id=467129f3"
import script from "./ProcessEditor.vue?vue&type=script&lang=js"
export * from "./ProcessEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports